import { ReactElement } from 'react'
import { isString, uniqueID } from '@ally/utilitarian'

export type ItemContent = string | ReactElement

export const generateKey = (itemKey: ItemContent): string => {
  return isString(itemKey) ? itemKey : uniqueID()
}
